<template>
  <div>
    <spinner v-if="loading" />
    <div v-else>
      <div v-for="(ticket, index) in ticketsInfo" :key="index">
        <div
          v-if="
            [194, 294].includes(Number(organization.id)) ||
              Number(ticketSellerOrganization.id) === 33
          "
          :class="[
            'ticket-container',
            {
              'zf-ticket-container': Number(organization.id) === 294,
              'cibona-ticket-container': Number(ticketSellerOrganization.id) === 33,
            },
          ]"
          :style="index !== ticketsInfo.length - 1 && 'page-break-after: always'"
        >
          <fraktura-ticket-seller-pdf
            v-if="Number(organization.id) === 194"
            :event-info="eventInfo"
            :organization="organization"
            :index="index"
            :ticket-info="ticket"
          />
          <zf-ticket-seller-pdf
            v-else-if="Number(organization.id) === 294"
            :event-info="eventInfo"
            :ticket-count="ticketsInfo.length"
            :organization="organization"
            :index="index"
            :ticket-info="ticket"
          />
          <cibona-ticket-seller-pdf
            v-else-if="Number(ticketSellerOrganization.id) === 33"
            :event-info="eventInfo"
            :organization="organization"
            :index="index"
            :ticket-info="ticket"
            :ticket-name="getDisplayTicketName(ticket)"
            :order-payment-type="order.paymentType"
          />
        </div>
        <pdf-ticket
          v-else
          :print-design="true"
          :event-info="eventInfo"
          :buyer="buyer"
          :seller-name="sellerName"
          :is-custom-fiscalisation="isCustomFiscalisation"
          :ticket-seller-organization="ticketSellerOrganization"
          :hide-price="hidePrice"
          :purchased-at="ticket.createdAt"
          :organization="organization"
          :ticket-name="getDisplayTicketName(ticket)"
          :ticket-price="ticket.orderItem.price"
          :order-payment-type="order.paymentType"
          :ticket-location="ticket.accreditation.ticketLocation"
          :qrcode="ticket.accreditation.qrcode"
          :barcode="ticket.accreditation.barcode"
          :fiscalisation-info="fiscalisationInfo"
          :order-number="`${ticket.orderId}-${index + 1}`"
          :ticket-index="index"
          :tickets-info="ticketsInfo"
          :show-ticket-owner="eventInfo.ticketPersonalization"
          :ticket-owner-name="getTicketOwnerName(ticket)"
        />
      </div>
      <ticket-seller-ticket-invoice-pdf
        v-if="
          Number(organization.id) !== 294 &&
            Number(ticketSellerOrganization.id) !== 33 &&
            order.paymentType !== 'FREE'
        "
        :fiscalisation-info="fiscalisationInfo"
        :ticket-seller-organization="ticketSellerOrganization"
        :organization="organization"
        :event-info="eventInfo"
        :buyer="buyer"
        :tickets-info="ticketsInfo"
        :order="order"
      />
      <div
        v-else-if="Number(ticketSellerOrganization.id) === 33 && order.paymentType !== 'FREE'"
        class="ticket-container cibona-ticket-container"
      >
        <kk-cibona-ticket-seller-invoice-pdf
          :fiscalisation-info="fiscalisationInfo"
          :ticket-seller-organization="ticketSellerOrganization"
          :organization="organization"
          :event-info="eventInfo"
          :buyer="buyer"
          :tickets-info="ticketsInfo"
          :order="order"
        />
      </div>
      <div
        v-if="
          ![194, 188, 294].includes(Number(organization.id)) &&
            Number(ticketSellerOrganization.id) !== 33
        "
      >
        <div v-for="(notATicket, i) in notATickets" :key="'not' + i">
          <not-a-ticket :is-last="i + 1 === notATickets.length" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import 'moment-timezone'
import pdfTicket from './pdf-ticket.vue'
import notATicket from './not-a-ticket.vue'
import FrakturaTicketSellerPdf from '@/components/builder/FrakturaTicketSellerPdf.vue'
import { getOrderInfoByUUID } from '../../http'
import i18next from 'i18next'
import TicketSellerTicketInvoicePdf from '@/components/ticket-seller/tickets/ticket-seller-ticket-invoice-pdf.vue'
import ZfTicketSellerPdf from '@/components/builder/ZFTicketSellerPdf.vue'
import CibonaTicketSellerPdf from '@/components/builder/CibonaTicketSellerPdf.vue'
import KkCibonaTicketSellerInvoicePdf from '@/components/ticket-seller/tickets/kk-cibona-ticket-seller-invoice-pdf.vue'

export default {
  name: 'ticket-seller-pdf',
  components: {
    ZfTicketSellerPdf,
    TicketSellerTicketInvoicePdf,
    pdfTicket,
    notATicket,
    FrakturaTicketSellerPdf,
    CibonaTicketSellerPdf,
    KkCibonaTicketSellerInvoicePdf,
  },
  props: {
    uuid: String,
  },
  data() {
    return {
      purchases: [],
      loading: true,
      eventInfo: {},
      notATickets: 0,
      sellerName: '',
      buyer: {},
      ticketsInfo: [],
      orderCreatedAt: '',
      organization: null,
      isCustomFiscalisation: false,
      ticketSellerOrganization: {},
      hidePrice: false,
      fiscalisationInfo: {},
      order: {},
    }
  },
  async mounted() {
    const params = new URL(document.location).searchParams
    this.hidePrice = params.get('hidePrice') === 'true'
    const {
      buyer,
      user: { type, ...userData },
      event: {
        id,
        location: { address1, city, country, postalCode, venue },
        from,
        to,
        title,
        organization,
        fixedFeePerTicket,
        variableFeePercentage,
        extraModules,
      },
      ...eventDetails
    } = await getOrderInfoByUUID(this.uuid)
    this.hidePrice = eventDetails.paymentType === 'FREE'
    this.buyer = buyer
    this.ticketsInfo = eventDetails.purchases
    this.order = eventDetails

    const totalParts = eventDetails.purchases.length + (eventDetails.paymentType !== 'FREE' ? 1 : 0)
    if (totalParts % 4 > 0) {
      this.notATickets = Array(4 - (totalParts % 4)).fill('notATicket')
    }

    this.sellerName = type === 'TICKET_SELLER' ? userData.ticketSellerOrganization.name : ''
    this.isCustomFiscalisation =
      (userData.ticketSellerOrganization &&
        userData.ticketSellerOrganization.isCustomFiscalisation) ||
      false
    this.ticketSellerOrganization = (userData && userData.ticketSellerOrganization) || {}
    this.fiscalisationInfo = { ...eventDetails.fiscalisationInfo, totalPrice: 0 }

    eventDetails.purchases.forEach(p => {
      this.fiscalisationInfo.totalPrice += Number(Math.round(p.orderItem.price * 100).toFixed(2))
    })

    i18next.changeLanguage(organization.preferredLanguage === 'en' ? 'en' : 'hr')
    this.organization = { ...organization }

    const isSameDay = moment(from).isSame(moment(to), 'day')

    const eventAddress = [address1, city, country].filter(e => e != null && e !== '').join(', ')

    this.eventInfo = {
      id,
      eventTitle: title,
      eventAddress: eventAddress,
      fixedFeePerTicket,
      variableFeePercentage,
      eventDate: `${this.formatDate(from, true)}${
        !isSameDay ? ` - ${this.formatDate(to, false)}` : ''
      }`,
      eventFrom: from,
      venue,
      address1,
      postalCode,
      city,
      country,
      ticketPersonalization: !!(extraModules && extraModules.ticketPersonalization),
    }
    this.loading = false

    setTimeout(window.print, 1000)
  },
  methods: {
    getDisplayTicketName(ticket) {
      const ticketName = (ticket && ticket.orderItem && ticket.orderItem.name) || ''
      const ticketAdditionalNote = this.buyer && this.buyer.ticketAdditionalNote

      return ticketAdditionalNote ? `${ticketName} - ${ticketAdditionalNote}` : ticketName
    },
    formatDate(date, withHours = true) {
      return (
        moment(date)
          .tz('Europe/Zagreb')
          .format(`DD. MMMM YYYY.${withHours ? ' u HH:mm' : ''}`) + `${withHours ? ' sati' : ''}`
      )
    },
    getTicketOwnerName(ticket) {
      const fields = (ticket.accreditation && ticket.accreditation.fields) || {}
      const firstName = fields['First name'] || fields.firstName || ''
      const lastName = fields['Last name'] || fields.lastName || ''

      return [firstName, lastName].filter(Boolean).join(' ')
    },
  },
}
</script>

<style scoped>
.page-break {
  page-break-after: always;
}

.ticket-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 6.08cm !important;
  height: 16.62cm !important;
  overflow: hidden;
  box-sizing: border-box;
  break-inside: avoid;
  page-break-inside: avoid;
  transform: rotateY(180deg);
  transform: rotateX(20deg);
}
.zf-ticket-container {
  height: 175mm !important;
  width: 80mm !important;
}
.cibona-ticket-container {
  height: 210mm !important;
  width: 80mm !important;
  overflow: hidden;
}
</style>
